import { GameStatues, IGame } from "./../../entities";
import { provider } from "../../providers";

export interface GetGameNextStatusesPayload {
  game: IGame;
}

export const GetGameNextStatuses = async (params: GetGameNextStatusesPayload): Promise<GameStatues[]> =>
  provider.Request("/games/next-statuses", params);
